<template>
  <div
    class="tm-table-container"
    :class="{
      'tm-table-container--theme-borderless': theme === TableTheme.BORDERLESS,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { TableTheme } from '@/components/shared/table/types'

defineProps<{
  theme?: TableTheme
}>()
</script>

<style scoped lang="scss">
@import '@/styles/table';

.tm-table-container {
  border: var(--tm-table-border-width) solid var(--tm-table-border-color);
  border-radius: var(--tm-table-border-radius);
  box-shadow: $table-shadow;
  overflow: clip;
  box-sizing: content-box;

  &--theme-borderless {
    border: none;
    border-radius: 0;
    box-shadow: none;
  }

  &:has(.tm-table.tm-table--loading .tm-skeleton-table-body-row-layout) {
    mask-image: linear-gradient(to bottom, #fff 0%, #fff 0%, transparent);
  }
}
</style>
